'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('slick-carousel');

require('slick-carousel/slick/slick.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var jQuery = _jquery2.default;
(function ($) {
  // create temporal object to get slick object

  // !!!!!!!!!!!
  // getSlick() -> TO CHYBA CZASEM ROZWALA CAY SKRYPT (Maximum stack exceded)
  // !!!!!!!!!!!

  var getSlick = function getSlick() {
    var $tmp = $('<div>').slick();
    var slick = $tmp[0].slick.constructor;
    $tmp.slick('unslick');
    return slick;
  };

  if ($.fn.slick) {
    var Slick = getSlick();
    if (Slick) {
      // hook checkResponsive method
      var checkResponsiveOrig = Slick.prototype.checkResponsive;
      Slick.prototype.checkResponsive = function (initial, forceUpdate) {
        var _ = this;
        if (_.options.autoSlidesToShow && !_.options.infinite && _.options.variableWidth) {
          var sliderWidth = _.$slider.width();
          var width = 0,
              length = _.$slides.length;
          for (var i = 0; i < length; i++) {
            width += $(_.$slides[i]).outerWidth();
          }
          _.averageSlidesWidth = width / length;
          _.options.slidesToShow = Math.floor(sliderWidth / _.averageSlidesWidth) || 1;
          // force update arrows
          if (_.lastSlidesToShow !== _.options.slidesToShow) {
            _.lastSlidesToShow = _.options.slidesToShow;
            if (initial === true) {
              _.currentSlide = _.options.initialSlide;
            }
            _.refresh(initial);
          }
        }
        return checkResponsiveOrig.apply(this, arguments);
      };
      // hook getLeft method
      var getLeftOrig = Slick.prototype.getLeft;
      Slick.prototype.getLeft = function (slideIndex) {
        var _ = this;
        if (_.options.autoSlidesToShow && !_.options.infinite && _.options.variableWidth) {
          var targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
          if (targetSlide[0]) {
            var diff = 0;
            if (slideIndex) {
              var sliderWidth = _.$slider.width();
              var otherSlidesWidth = (_.slideCount - slideIndex) * _.averageSlidesWidth;
              if (otherSlidesWidth < sliderWidth) {
                diff = sliderWidth - otherSlidesWidth;
              }
            }
            return (targetSlide[0].offsetLeft - diff) * -1;
          }
          return 0;
        }
        return getLeftOrig.apply(this, arguments);
      };
    }
  }
})(jQuery);

var Process = {
  init: function init() {
    var _$$slick;

    (0, _jquery2.default)('.slickjs').each(function () {
      (0, _jquery2.default)(this).slick({
        dots: true,
        infinite: true,
        speed: 500,
        fade: true,
        cssEase: 'linear',
        rows: 0,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        appendDots: (0, _jquery2.default)(this).closest('.process').find('.dots-container')
      });
    });
    (0, _jquery2.default)('.slickjs-nav').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: '.slickjs',
      dots: false,
      focusOnSelect: true,
      fade: true,
      rows: 0,
      arrows: false
      //			  prevArrow: 'arrow-left',
      //			  nextArrow: 'arrow-right'
    });

    (0, _jquery2.default)('.slickjs-2').slick((_$$slick = {
      dots: false,
      infinite: true,
      speed: 500,
      fade: true
    }, (0, _defineProperty3.default)(_$$slick, 'infinite', false), (0, _defineProperty3.default)(_$$slick, 'cssEase', 'linear'), (0, _defineProperty3.default)(_$$slick, 'rows', 0), (0, _defineProperty3.default)(_$$slick, 'arrows', false), (0, _defineProperty3.default)(_$$slick, 'slidesToShow', 1), (0, _defineProperty3.default)(_$$slick, 'slidesToScroll', 1), _$$slick));

    (0, _jquery2.default)('.slickjs-3').slick({
      dots: true,
      infinite: true,
      speed: 500,
      lazyLoad: 'progressive',
      cssEase: 'linear',
      rows: 0,
      touchThreshold: 20,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1
    });

    (0, _jquery2.default)('.slickjs-4').slick({
      dots: false,
      infinite: true,
      speed: 500,
      fade: true,
      lazyLoad: 'progressive',
      cssEase: 'linear',
      rows: 0,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1
    });

    (0, _jquery2.default)('.slickjs-3-nav').slick({
      dots: false,
      infinite: false,
      //				  centerMode: true,
      focusOnSelect: true,
      speed: 500,
      cssEase: 'linear',
      asNavFor: '.slickjs-3',
      rows: 0,
      arrows: true,
      //				  autoSlidesToShow: true,
      //				  variableWidth: true,
      slidesToShow: 4,
      responsive: [{
        breakpoint: 768,
        settings: {
          centerMode: false
        }
      }]
    });

    (0, _jquery2.default)('.slickjs-nav-2').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: '.slickjs-2',
      dots: true,
      focusOnSelect: true,
      fade: true,
      infinite: false,
      rows: 0,
      arrows: true
      //			  prevArrow: 'arrow-left',
      //			  nextArrow: 'arrow-right'
    });

    (0, _jquery2.default)('.about-carousel').slick({
      dots: false,
      infinite: true,
      lazyLoad: 'progressive',
      speed: 500,
      cssEase: 'linear',
      arrows: true,
      slidesToShow: 6,
      slidesToScroll: 1,
      responsive: [{
        breakpoint: 1024,
        settings: {
          arrows: false,
          slidesToShow: 3,
          slidesToScroll: 3,
          centerMode: true
        }
      }, {
        breakpoint: 600,
        settings: {
          arrows: false,
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 480,
        settings: {
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }]
    });
  }
};

exports.default = Process;